<template>
  <CRow>
    <CCol lg="12">

      <CModal
      :show.sync="showModal"
      :close-on-backdrop="false"
      :centered="true"
      color="dark"
      size="xl">

      <template #header>
        <strong class="modal-title">Tạo đơn hàng bước {{currentStep}}</strong>
        <span>Lưu ý: Những trường đánh dấu sao (*) là bắt buộc</span>
      </template>

        <CCol v-if="currentStep===1" style="min-height: 400px;">
        <CRow>
          <CCol sm="6">
            <CSelect
              :options="formData.productTypes"
              placeholder="Chọn loại sản phẩm"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <v-select
              :options="productsMainOption"
              label="label"
              :reduce="item => item.value"
              @input="handleUpdateSelectedProduct"
              placeholder="Chọn sản phẩm"
            >
              <template #option="{ label }">
                <div v-html="label"></div>
              </template>
              <template #selected-option="{ label }">
                <div v-html="label"></div>
              </template>
            </v-select>
          </CCol>
          <CCol>
            <div v-if="formData.productSku" class="wrap-text">
              Sku: {{formData.productSku}}
            </div>
            <div v-if="formData.productPrice" class="wrap-text">
              Giá bán: {{formatThousands(formData.productPrice)}} (vnđ)
            </div>
            <div v-if="formData.productLeadTime > 0" class="wrap-text">
              Thời gian sản xuất tiêu chuẩn: {{formData.productLeadTime}} (ngày)
            </div>
            <div v-if="formData.productAvailable" class="wrap-text">
              Tồn kho: {{formData.productAvailable}}
            </div>
            <div v-if="formData.productDocs" class="wrap-text">
              Tài liệu sản phẩm: <a :href="formData.productDocs" target="_blank" rel="noopener noreferrer">
              Đường dẫn</a>
            </div>
            <div  v-if="formData.productDesc" class="wrap-text box">
              Mô tả tóm tắt: {{formData.productDesc}}
            </div>
          </CCol>
        </CRow>
          <CRow>
            <CCol class="d-flex justify-content-center">
              <img v-if="formData.productImage!==''"
                   alt="hình ảnh"
                   :src="formData.productImage" style="width: 400px;">
            </CCol>
            <CCol class="d-flex justify-content-center">
              <img v-if="formData.productImage2!==''"
                   alt="hình ảnh"
                   :src="formData.productImage2" style="width: 400px;">
            </CCol>
          </CRow>
        </CCol>


        <CCol v-if="currentStep===2" style="min-height: 400px;">
          <CRow>
            <CCol>
              <CInput
                label="Số lượng đặt hàng (pcs)*:"
                type="number"
                v-model.number="formData.project.quantity"
                @change="updateQuantity"
                required
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CInput
                label="Hợp đồng:"
                placeholder="Mã hợp đồng"
                v-model="formData.project.contract"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol>
            <CInput
              label="Mã đặt hàng*:"
              placeholder="Mã đặt hàng"
              v-model="formData.project.preorder"
            />
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CInput
                label="Ngày thanh toán lần 1 (dự kiến)*:"
                type="date"
                v-model="formData.project.start" @change="onStartChange"
              />
            </CCol>
            <CCol>
              <CInput
                label="Ngày giao hàng (dự kiến)*:"
                type="date"
                v-model="formData.project.stop" :min="minStopDate"
              />
            </CCol>
          </CRow>
        </CCol>

        <CCol v-if="currentStep===3" style="min-height: 400px;">
          <CRow>
            <CCol>
              <div style="color: red;"><strong>Tóm tắt đơn hàng:</strong></div>
              <table>
                <tr><td class="text-right">Model:</td><td><strong>{{formData.project.product}}</strong></td></tr>
                <tr v-if="formData.productSku"><td class="text-right">Sku:</td> <td><strong>{{formData.productSku}}</strong></td></tr>
                <tr v-if="formData.productPrice"><td class="text-right">Giá bán:</td> <td><strong>{{formatThousands(formData.productPrice)}} (vnđ)</strong></td></tr>
                <tr><td class="text-right">Số lượng:</td> <td><strong>{{formatThousands(formData.project.quantity)}}</strong></td></tr>
                <tr v-if="formData.productPrice"><td class="text-right">Thành tiền chưa VAT:</td> <td>
                  <strong>{{formatThousands(Number(formData.project.quantity) * Number(formData.productPrice))}} (vnđ)</strong></td></tr>
                <tr v-if="formData.productVat"><td class="text-right">Thành tiền gồm VAT:</td> <td>
                  <strong>{{formatThousands(calcTotalPay(Number(formData.project.quantity) * Number(formData.productPrice)))}} (vnđ)</strong></td></tr>
                <tr><td class="text-right">Ngày đặt hàng:</td> <td><strong>{{formattedDate(formData.createOrder)}}</strong></td></tr>
                <tr><td class="text-right">Ngày thanh toán lần 1 (dự kiến):</td> <td><strong>{{formattedDate(formData.project.start)}}</strong></td></tr>
                <tr><td class="text-right">Ngày giao hàng (dự kiến):</td> <td><strong>{{formattedDate(formData.project.stop)}}</strong></td></tr>
              </table>
            </CCol>
            <CCol>
              <CTextarea
                label="Thông tin bổ sung đến nhà cung cấp:"
                type="text"
                placeholder="Ghi chú đơn hàng"
                v-model="formData.project.note"
                rows="6"
                maxLength="1000"
                :addLabelClasses="'text-right'"
              />
            </CCol>

          </CRow>
        </CCol>

      <template #footer>
        <CButton v-if="currentStep > 1" color="info" @click="prevStep" class="mr-1"><CIcon name="cil-chevron-left"/>Quay lại</CButton>
        <CButton v-if="currentStep < 3" color="info" :disabled="!allowNext" class="mr-1" @click="nextStep"><CIcon name="cil-chevron-right"/>Tiếp theo</CButton>
        <CButton v-if="currentStep > 2" color="success" @click="submitOrder" class="mr-1"><CIcon name="cil-save"/>Xác nhận</CButton>
        <CButton @click="goBack" color="danger" class="mr-1"><CIcon name="cil-trash"/>Hủy bỏ</CButton>
      </template>
    </CModal>

      <CCard v-if="!showModal">
        <CCardHeader>
          <strong v-if="userRole==='customer'">Thông tin đơn hàng, bấm 'Gửi OTP' để lấy OTP, nhập OTP và bấm 'Lưu lại' để xác nhận đơn hàng</strong>
          <strong v-else>Thông tin đơn hàng</strong>
          <div class="card-header-actions d-flex align-items-center">

            <CButton type="button" shape="pill" color="info"
                     class="mr-1" style=" width: 100px;"
                     @click="save"
                     :disabled="userRole==='customer' && otp===''"
            >
              <CIcon name="cil-save"/>
              Lưu lại</CButton>

            <CButton v-if="userRole==='customer'" type="button" shape="pill" color="warning"
                     class="mr-1" style=" width: 100px;"
                     @click="sendOtp">
              <CIcon name="cil-paper-plane"/>
              Gửi OTP</CButton>

            <CButton v-if="projectID!==''" type="button" shape="pill" color="secondary"
                     class="mr-1" style=" width: 100px;"
                     @click="refresh">
              <CIcon name="cil-sync"/>
              Tải lại</CButton>
            <CButton v-if="projectID" type="button" shape="pill" color="secondary"
                     class="mr-1" style=" width: 100px;"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
            <CButton v-else type="button" shape="pill" color="danger"
                     class="mr-1" style=" width: 100px;"
                     @click="goBack">
              <CIcon name="cil-trash"/>
              Hủy bỏ</CButton>

          </div>
        </CCardHeader>
        <CCardBody>
          <CRow v-if="userRole!=='customer'">
            <CCol>
              <CSelect
                label="Khách hàng*:"
                :options="formData.customer_names"
                :value.sync="formData.project.customer"
                placeholder="Chọn khách hàng"
                required
                horizontal
                :addLabelClasses="'text-right'"
              />
            </CCol>
          </CRow>

          <CRow v-else>
            <CCol sm="4">
              <span>
                Email nhận OTP:
                <strong>{{customerEmail}}</strong>
              </span>
            </CCol>
            <CCol sm="4">
              <span>
                Điện thoại nhận OTP:
                <strong>{{customerPhone}}</strong>
              </span>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <v-select
                :options="productsMainOption"
                label="label"
                v-model="formData.selectedProduct"
                :reduce="item => item.value"
                @input="handleUpdateSelectedProduct"
                placeholder="Chọn sản phẩm"
              >
                <template #option="{ label }">
                  <div v-html="label"></div>
                </template>
                <template #selected-option="{ label }">
                  <div v-html="label"></div>
                </template>
              </v-select>
              <div v-if="formData.productSku"  class="wrap-text">
                Sku: {{formData.productSku}}
              </div>
              <div v-if="formData.productPrice" class="wrap-text">
                Giá bán: {{formatThousands(formData.productPrice)}} (vnđ)
              </div>
              <div v-if="formData.productLeadTime > 0" class="wrap-text">
                Thời gian sản xuất tiêu chuẩn: {{formData.productLeadTime}} (ngày)
              </div>
              <div v-if="formData.productDocs" class="wrap-text">
                Tài liệu sản phẩm: <a :href="formData.productDocs" target="_blank" rel="noopener noreferrer">
                Đường dẫn</a>
              </div>
              <div class="wrap-text box">
                Mô tả tóm tắt: {{formData.productDesc}}
              </div>
            </CCol>
            <CCol class="d-flex justify-content-center">
              <img v-if="formData.productImage!==''"
                alt="hình ảnh"
                :src="formData.productImage" style="width: 400px;">
            </CCol>

            <CCol class="d-flex justify-content-center">
              <img v-if="formData.productImage2!==''"
                alt="hình ảnh"
                :src="formData.productImage2" style="width: 400px;">
            </CCol>
          </CRow>

          <CRow>
            <CCol>
              <CInput
                label="Hợp đồng:"
                placeholder="Mã hợp đồng"
                v-model="formData.project.contract"
              />
            </CCol>
            <CCol>
              <CInput
                label="Mã đặt hàng*:"
                placeholder="Mã đặt hàng"
                v-model="formData.project.preorder"
              />
            </CCol>
            <CCol>
              <CInput
                label="Hóa đơn:"
                placeholder="Mã hóa đơn"
                v-model="formData.project.invoice"
              />
            </CCol>
            <CCol sm="2">
              <CInput
                label="Ngày xuất hóa đơn:"
                type="date"
                v-model="formData.project.issued"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol>
              <CInput
                label="Số lượng đặt hàng (pcs)*:"
                type="number"
                v-model.number="formData.project.quantity"
                required
              />
            </CCol>
            <CCol>
              <CInput
                label="Ngày thanh toán lần 1 (dự kiến)*:"
                type="date"
                v-model="formData.project.start" @change="onStartChange"
              />
            </CCol>
            <CCol>
              <CInput
                label="Ngày giao hàng (dự kiến)*:"
                type="date"
                v-model="formData.project.stop" :min="minStopDate"
              />
            </CCol>
            <CCol>
              <CSelect
                label="Trạng thái đơn hàng:"
                :options="['Tạo mới', 'Đã xác nhận', 'Đang thực hiện', 'Quá hạn', 'Hoàn thành', 'Hủy bỏ']"
                :value.sync="formData.project.status"
                :disabled="userRole==='customer'"
              />
            </CCol>
            <CCol v-if="userRole==='customer'">
              <CInput
                label="Mã OTP nhận được*:"
                placeholder="Vui lòng nhập mã OTP trước khi bấm 'Lưu lại'"
                v-model="otp"
              />
            </CCol>
          </CRow>

          <CRow>

            <CCol>
              <div style="color: red;"><strong>Tóm tắt đơn hàng:</strong></div>
              <table>
              <tr><td class="text-right">Model:</td><td><strong>{{formData.project.product}}</strong></td></tr>
              <tr v-if="formData.productSku"><td class="text-right">Sku:</td> <td><strong>{{formData.productSku}}</strong></td></tr>
              <tr v-if="formData.productPrice"><td class="text-right">Giá bán:</td> <td><strong>{{formatThousands(formData.productPrice)}} (vnđ)</strong></td></tr>
              <tr><td class="text-right">Số lượng:</td> <td><strong>{{formatThousands(formData.project.quantity)}}</strong></td></tr>
              <tr v-if="formData.productPrice"><td class="text-right">Thành tiền chưa VAT:</td> <td>
                <strong>{{formatThousands(Number(formData.project.quantity) * Number(formData.productPrice))}} (vnđ)</strong></td></tr>
              <tr v-if="formData.productVat"><td class="text-right">Thành tiền gồm VAT:</td> <td>
                <strong>{{formatThousands(calcTotalPay(Number(formData.project.quantity) * Number(formData.productPrice)))}} (vnđ)</strong></td></tr>
              <tr><td class="text-right">Ngày đặt hàng:</td> <td><strong>{{formattedDate(formData.createOrder)}}</strong></td></tr>
              <tr><td class="text-right">Ngày thanh toán lần 1 (dự kiến):</td> <td><strong>{{formattedDate(formData.project.start)}}</strong></td></tr>
              <tr><td class="text-right">Ngày giao hàng (dự kiến):</td> <td><strong>{{formattedDate(formData.project.stop)}}</strong></td></tr>
              </table>
            </CCol>
            <CCol>
              <CTextarea
                label="Thông tin bổ sung đến nhà cung cấp:"
                type="text"
                placeholder="Ghi chú đơn hàng"
                v-model="formData.project.note"
                rows="6"
                maxLength="1000"
                :addLabelClasses="'text-right'"
              />
            </CCol>

          </CRow>

          <CRow>
            <CCol md="3" class="text-right mt-1 p-0">
              Đính kèm bản scan đã ký đóng dấu:
            </CCol>
            <CCol>
              <CSpinner
                v-if="formData.isUploading"
                color="info"
                class="mr-5 mt-0"
                style="width:1.2rem;height:1.2rem;"
              />

              <CIcon name="cil-paperclip" class="mr-2"/>
              <label
                style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                class="mr-1"
                for="fileInput"
              >{{ formData.fileName }}
              </label>
              <input type="file"
                     id="fileInput"
                     style="display: none;"
                     @change="onFileChange">

              <CButton v-if="formData.selectedFile" shape="pill" color="info"
                       class="mr-2"
                       @click="handleUpload"
                       :disabled="formData.isUploading"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploading ? "Đang tải..." : "Tải lên" }}
              </CButton>

              <CButton v-if="formData.gotInfo && formData.project.attached" shape="pill" color="info"
                       class="mr-2"
                       @click="downloadFile(formData.project.attached)"
              ><CIcon name="cil-cloud-download" class="mr-1"/>Tải xuống</CButton>

              <CButton v-if="formData.gotInfo && formData.project.attached" shape="pill" color="info"
                       @click="previewFile(formData.project.attached)"
              ><CIcon name="cil-screen-desktop" class="mr-1"/>Xem/Ẩn</CButton>

            </CCol>
            <CCol>
              <div v-if="formData.project.gen_file">
                <span>Tệp thông tin đơn hàng:<a v-if="formData.gotInfo && formData.project.gen_file"
                                       href="#"
                                       @click="downloadFile(formData.project.gen_file)">
                {{formData.project.gen_file}}</a></span>

              </div>
            </CCol>
          </CRow>

          <div v-if="formData.pdfUrl" class="resizable-container mb-2">
            <iframe :src="formData.pdfUrl" width="100%" height="100%"></iframe>
          </div>

        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      showModal: true,
      currentStep: 1,
      projectID: '',
      otp: '',
      userRole: '',
      userName: '',
      formData: this.defaultData()
    }
  },
  watch: {
    $route(to, from) {
      if(!this.$route.query.id) {
        // console.log('request create new')
        this.formData = this.defaultData()
        this.getProjectDetail(this.projectID);
        this.projectID=''
        this.openModal();
      } else {
        this.closeModal()
      }
    },
    showModal(newVal, oldVal) {
      //console.log(oldVal, newVal)
    }
  },
  created() {
    this.getUserRole()
    this.projectID = this.$route.query.id
    if(this.projectID) {
      this.closeModal()
    }
    this.getProjectDetail(this.projectID);
    if (this.formData.project.start !== '' &&
      this.formData.project.stop === '' &&
      this.formData.productLeadTime > 0) {
      this.onStartChange()
    }
  },
  computed:{
    productsMainOption() {
      return this.formData.products.map(item => {
        let skuLines = "";
        if (item.sku) {
          let skuStr = item.sku.replace(/\n/g, "<br>")
            skuLines = skuStr
            .split(";")
            .map((sku, index) => `Sku #${index + 1}: ${sku.trim()}`)
            .join("<br>");
        }

        return {
          value: item.product,
          label: `<div style="line-height: 0.9;"><strong>${item.product}</strong><br><small>${skuLines}</small></div>`
        };
      });
    },
    customerEmail() {
      return this.formData.customer && this.formData.customer.email ? this.formData.customer.email : '';
    },
    customerPhone() {
      return this.formData.customer && this.formData.customer.phone ? this.formData.customer.phone : '';
    },
    minStopDate() {
      if (!this.formData.project.start || this.formData.productLeadTime === 0) return ''
      const date = new Date(this.formData.project.start)
      date.setDate(date.getDate() + this.formData.productLeadTime)
      return this.formatDate(date)
    },
    allowNext(){
      if(this.currentStep < 3) {
        if(this.currentStep === 1) {
          return this.formData.project.product;
        } else if(this.currentStep === 2) {
          return this.formData.project.preorder &&
            this.formData.project.start &&
            this.formData.project.stop && this.formData.project.quantity > 0;
        } else if (this.currentStep === 3) {
          return false
        }
      }
      return false;
    }
  },
  methods: {
    defaultData() {
      const today = new Date();
      const createStr=today.toISOString().split("T")[0]
      const startStr=today.toISOString().split("T")[0]
      return {
        project: { // project basic info
          id: 0,
          project: '',
          preorder: '',
          customer: '',
          contract: '',
          product: '',
          quantity: 0,
          who: '',
          created: createStr,
          start: startStr,
          stop: '',
          status: 'Tạo mới',
          priority: 3,
          invoice: '',
          issued: '',
          note: '',
          updated: '',
          attached: '',
          gen_file: '',
        },
        customer: null,
        productTypes: [],
        products: [],
        selectedProduct: null,
        products_used: [],
        customer_names: [],
        product_names: [],
        fileName: 'Chọn tệp',
        selectedFile: null,
        isUploading: false,
        progress: null,
        gotInfo: false,
        preview: true,
        pdfUrl: null,
        productImage: '',
        productImage2: '',
        productDesc: '',
        productSku: '',
        productDocs: '',
        productPrice: 0,
        productVat: 0, // VAT in percent
        productAvailable: 0,
        productLeadTime: 0,
        productGroup: '',
        createOrder: createStr,
      }
    },
    getUserRole() {
      this.userRole = localStorage.getItem('role')
      this.userName = localStorage.getItem('username')
    },
    getProjectDetail(projectID) {
      console.log('do get user detail for: ', projectID);
      this.$request.get(`/api/project/${projectID}`).then(res => {
        console.log(res.data);
        if(res.data.product_names) {
          this.formData.product_names = res.data.product_names;
        }

        if(res.data.customer_names && this.userRole !== 'customer') {
          this.formData.customer_names = (res.data.customer_names || []).filter(name => name !== 'Công ty tôi');
        }

        if(res.data.member_names) {
          this.formData.member_names = res.data.member_names
        }
        this.formData.customer = res.data.customer;
        this.formData.products = res.data.products;
        if (this.projectID || this.formData.project.project) {
          this.formData.project = res.data.project;
          if(this.formData.project.attached!=='') {
            this.formData.fileName = this.formData.project.attached;
          }
          this.handleUpdateSelectedProduct(this.formData.project.product);
          this.formData.selectedProduct = this.productsMainOption.find(
            item => item.value === this.formData.project.product
          );
          console.log(this.formData.selectedProduct)
          this.formData.gotInfo=true
        }

      })
    },
    refresh() {
      if (this.projectID) {
        this.getProjectDetail(this.projectID)
      }
    },
    sendOtp(){
      this.$swal.fire({
        title: "Gửi OTP cho " + this.userName + "?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.get(`/api/project/createotp`).then(res => {
            if(res.data.status.includes('đã gửi')) {
              this.$swal.fire({
                icon: "success",
                title: "Tạo mã OTP",
                text: res.data.status ,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Tạo mã OTP",
                html: "Tạo mã OTP thất bại <br>lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    save() {

      if(this.userRole === 'customer' && this.otp === '') {
        this.$swal.fire({
          icon: "error",
          title: "Lưu đơn hàng",
          html: "Bạn cần nhập mã OTP nhận được qua email hoặc SMS trước khi lưu!"
        });
        return;
      }
      this.$swal.fire({
        title: (this.projectID) ? "Cập nhật đơn hàng?" : "Tạo mới đơn hàng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          if(this.userRole === 'customer') {this.formData.project.customer=this.userName}
          this.$request.post(`/api/project/basic`,
            {otp: this.otp, project: this.formData.project, products_used: this.formData.products_used}).then(res => {
            this.formData.project = res.data.project;
            this.formData.gotInfo=true
            if(res.data.status === 'success') {
              let successCreate = "<span style='color: red'>Đơn hàng số: <strong>" + this.formData.project.preorder +
                "</strong><br>được tạo mới thành công. Cảm ơn bạn đã đặt hàng, chúng tôi sẽ cập nhật trạng thái đơn hàng của bạn chậm nhất sau 1 ngày làm việc!</span>"
              let successEdit =  "Đơn hàng số: " + this.formData.project.preorder + " được cập nhật thành công"
              this.$swal.fire({
                icon: "success",
                title: (this.projectID) ? "Cập nhật  đơn hàng" : "Tạo mới đơn hàng",
                html: this.projectID ? successEdit : successCreate
              });
            } else {
              let errorCreate = "Tạo mới đơn hàng " + this.formData.project.preorder + "<br>lỗi: " + res.data.status
              let errorEdit = "Cập nhật đơn hàng " + this.formData.project.preorder + "<br>lỗi: " + res.data.status
              this.$swal.fire({
                icon: "error",
                title: (this.projectID)  ?  "Cập nhật  đơn hàng" : "Tạo mới đơn hàng",
                html: (this.projectID)  ? errorEdit : errorCreate
              });
            }
          })
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    onFileChange(event) {
      this.formData.selectedFile = event.target.files[0];
      if (this.formData.selectedFile) {
        this.formData.fileName = this.formData.selectedFile.name;
      } else {
        this.formData.fileName = 'Chọn tệp chỉ tiêu kỹ thuật'
      }
    },
    handleUpload() {
      if (!this.formData.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.formData.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.formData.selectedFile);
      formData.append("id", this.formData.project.id)
      // Send file using Axios
      this.$request.post(`/api/project/docupload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
          if (res.data.status === 'success') {
            // console.log(res.data.status)
            this.$swal.fire({
              icon: "success",
              title: "Tải lên tệp",
              text: "Tệp: " + this.formData.fileName + " đã tải lên thành công!",
            });
            this.formData.project.attached=this.formData.fileName;
            if(this.userRole === 'customer') {this.formData.project.formData.customer=this.userName}
            this.$request.post(`/api/project/basic`,
              {otp: this.otp, project: this.formData.project}).
            then(res => {
              if(res.data.status === 'success') {
                this.formData.project = res.data.project;
                this.formData.selectedFile=null
                this.formData.gotInfo = true
              }
            })
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.formData.fileName + " lưu lỗi: "+ res.data.status,
            });
          }
          this.formData.isUploading = false;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Lưu tệp đính kèm",
            html: "Tệp: " + this.formData.fileName + " lưu lỗi: " + error,
          });
          this.formData.isUploading = false;
        });
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/project/docdownload/${fileName}?id=${this.formData.project.id}`,
        { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    previewFile(fileName) {
      if (this.formData.pdfUrl) {
        this.formData.pdfUrl = null
        return
      }
      this.$request.get(`/api/project/docdownload/${fileName}?id=${this.formData.project.id}&&preview=yes`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.formData.pdfUrl = URL.createObjectURL(blob);
      }).catch((error) => {
        console.error("Error converting DOCX to PDF:", error);
      });
    },
    handleUpdateSelectedProduct(newValue) {
      const selectedItem = this.formData.products.find(item => item.product === newValue);
      if (selectedItem) {
        this.formData.project.product=selectedItem.product;
        this.formData.productImage = selectedItem.image
        this.formData.productImage2 = selectedItem.image2
        this.formData.productDesc = selectedItem.description;
        this.formData.productSku = selectedItem.sku;
        this.formData.productDocs = selectedItem.datasheet;
        this.formData.productLeadTime = Number(selectedItem.lead_time);
        this.formData.productGroup = selectedItem.group;
        this.formData.productAvailable = selectedItem.available;
        this.formData.productPrice = selectedItem.price;
        this.formData.productVat = selectedItem.vat;

        //P.XX.DD.MM.YY-TACOMA
        if (this.userRole==='customer' && !this.projectID && this.showModal) {
          this.formData.project.preorder = "P." + this.formData.project.quantity +
            "." + this.getDateTimeString() + "-" + this.userName
        }
        this.onStartChange()
        this.formData.selectedProduct = this.productsMainOption.find(
          item => item.value === this.formData.project.product
        );
      }
    },
    formattedDate(istr) {
      if (!istr) return ''
      const [year, month, day] = istr.split('-')
      return `${month}/${day}/${year}`
    },
    onStartChange() {
      if(this.formData.project.start) {
        const date = new Date(this.formData.project.start)
        date.setDate(date.getDate() + this.formData.productLeadTime)
        this.formData.project.stop = this.formatDate(date)
      }
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    openModal(){
      this.showModal = true
      this.currentStep = 1
    },
    closeModal() {
      this.showModal = false
      this.currentStep = 1
    },
    nextStep(){
      if (this.currentStep < 3)
        this.currentStep++
    },
    prevStep() {
      if (this.currentStep > 1)
        this.currentStep--
    },
    submitOrder() {
      this.closeModal()
    },
    getDateTimeString() {
      const now = new Date()
      const dd = String(now.getDate()).padStart(2, '0')
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const yy = String(now.getFullYear()).slice(-2)
      return `${dd}.${mm}.${yy}`
    },
    formatThousands(number) {
      if (typeof number !== 'number') return '';
      return number.toLocaleString('vi-VN');
    },
    updateQuantity() {
      if (this.userRole==='customer' && !this.projectID && this.showModal) {
        this.formData.project.preorder = "P." + this.formData.project.quantity +
          "." + this.getDateTimeString() + "-" + this.userName
      }
    },
    calcTotalPay(value) {
      return ((this.formData.productVat / 100) * value) + value
    }
  }
}
</script>

<style scoped>
.resizable-container {
  width: 100%;
  height: 700px;
  resize: vertical; /* Allows vertical resizing */
  overflow: auto; /* Ensures scrollbars appear when needed */
  border: 1px solid #ccc; /* Optional: for better visibility */
  padding: 5px;
}
.wrap-text {
  white-space: pre-line;      /* Cho phép xuống dòng khi cần */
  word-wrap: break-word;    /* Tự động xuống dòng nếu gặp từ dài */
  word-break: break-word;   /* Hỗ trợ trình duyệt cũ hoặc từ không có dấu cách */
}
.box {
  min-height: 50px;
}
.custom-small {
  line-height: 0.8; /* hoặc giá trị khác như 20px, 150%, etc. */
}
</style>
